import { MENU_JIAMENG_SCHEDULE, JIAMENG_SCHEDULE } from '@constant'

export default {
  key: MENU_JIAMENG_SCHEDULE,
  id: '',
  title: '日程',
  icon: 'icon-richeng',
  link: JIAMENG_SCHEDULE
}
